import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import { ColumnDescriptor } from '../../People/FilterablePeopleTable/FilterablePeopleTableColumnSelectorModal/types';

interface RowDetailModalProps {
  isOpen: boolean;
  toggle: () => void;
  // The team dashboard columns to show as field name / value pairs.
  columns: ColumnDescriptor[];
  // The selected row (person object built by getPersonFromPeopleDataset).
  person: { [key: string]: any };
  // Reuses the team dashboard cell renderer so the values match the table.
  getField: (
    person: { [key: string]: any },
    column: ColumnDescriptor,
    uniqueIndexIdentifier: string,
    rowIndex: number,
    expanded?: boolean
  ) => React.ReactNode;
}

const RowDetailModal: React.FC<RowDetailModalProps> = ({
  isOpen,
  toggle,
  columns,
  person,
  getField,
}) => {
  const personName = person?.full_name ?? person?.person?.full_name;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable zIndex={900}>
      <ModalHeader toggle={toggle}>
        {personName ? (
          <FormattedMessage
            id="app.views.widgets.dashboards.team_dashboard.row_detail_modal.title_with_name"
            defaultMessage="Details for {name}"
            values={{ name: personName }}
          />
        ) : (
          <FormattedMessage
            id="app.views.widgets.dashboards.team_dashboard.row_detail_modal.title"
            defaultMessage="Row details"
          />
        )}
      </ModalHeader>
      <ModalBody>
        <Table responsive size="sm" className="card-table mb-3">
          <tbody>
            {columns.map((column, index) => (
              <tr key={column.field ?? index}>
                <th
                  scope="row"
                  className="text-muted align-top fw-normal"
                  style={{ width: '40%' }}
                >
                  {column.fullName ?? column.name}
                </th>
                <td className="align-top">
                  {getField(person, column, `row-detail-${index}`, index, true)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
};

export default RowDetailModal;
